import React, { useEffect, useState } from "react"
import { formatDateDataGrid } from "src/utils/format-date"
import PropTypes from 'prop-types'
import dayjs from "dayjs"
import { DATE_FORMAT } from "src/utils/constants"
import DatalakeService from "src/services/datalake-service"
import ParameterPaginationTable from "src/components/table/parameter-pagination-table"

const ParameterDatalakeB3AcoesRegistradoTable = (props) => {
    const dataLakeService = new DatalakeService()
    const [data, setData] = useState([])
    const [pagination, setPagination] = useState({ count: 0, next: null, previous: null })

    useEffect(() => {
        loadData()
    }, [])

    const loadData = () => {
        props.loading(true)
        dataLakeService.loadPaginationEndpoint(props.endpoint).then((response) => {
            props.loading(false)

            const { body } = response
            const { results, count, next, previous } = body
            const list = results.map((obj, index) => ({ ...obj, id: index }))

            setPagination({ count, next, previous })
            setData(list)
        })
    }

    const createRow = async () => {
        const body = {
            CodigoB3: "N/A",
            ISIN: "N/A",
            CodigoCFI: "N/A",
            Ativo: "N/A",
            DescricaoAtivo: "N/A",
            Segmento: "N/A",
            Mercado: "N/A",
            Categoria: "N/A",
            DataExpiracao: dayjs().format(DATE_FORMAT),
            DataInicioNegocio: dayjs().format(DATE_FORMAT),
            DataFimNegocio: dayjs().format(DATE_FORMAT),
            TipoOpcao: "N/A",
            TamanhoLote: 0,
            MoedaNegociada: "N/A",
            TipoEntrega: "N/A",
            PrecoExercicio: 0,
            EstiloOpcao: "N/A",
            IndicadorPremio: "N/A",
            IdentificadorDistribuicao: 0,
            FatorPreco: 0,
            Liquidacao: 0,
            TipoSerie: "N/A",
            IndicadorProtecao: "N/A",
            ExercicioAutomatico: "N/A",
            CodEspecificacao: "N/A",
            NomeInstituicao: "N/A",
            DataInicioEventoCorporativo: dayjs().format(DATE_FORMAT),
            TratamentoCustodia: "N/A",
            CapitalSocial: 0,
            GovernancaCorporativa: "N/A"
        }


        props.loading(true)
        return dataLakeService.createTableEndpoint(props.endpoint, body).then(() => {
            props.loading(false)
            loadData(0, 25)
        }).catch((err) => {
            props.loading(false)
            throw err
        })
    }

    const updateRow = async (newRow) => {
        const {
            ID,
            CodigoB3,
            ISIN,
            CodigoCFI,
            Ativo,
            DescricaoAtivo,
            Segmento,
            Mercado,
            Categoria,
            DataExpiracao,
            DataInicioNegocio,
            DataFimNegocio,
            TipoOpcao,
            TamanhoLote,
            MoedaNegociada,
            TipoEntrega,
            PrecoExercicio,
            EstiloOpcao,
            IndicadorPremio,
            IdentificadorDistribuicao,
            FatorPreco,
            Liquidacao,
            TipoSerie,
            IndicadorProtecao,
            ExercicioAutomatico,
            CodEspecificacao,
            NomeInstituicao,
            DataInicioEventoCorporativo,
            TratamentoCustodia,
            CapitalSocial,
            GovernancaCorporativa
        } = newRow

        const body = {
            CodigoB3,
            ISIN,
            CodigoCFI,
            Ativo,
            DescricaoAtivo,
            Segmento,
            Mercado,
            Categoria,
            DataExpiracao,
            DataInicioNegocio,
            DataFimNegocio,
            TipoOpcao,
            TamanhoLote,
            MoedaNegociada,
            TipoEntrega,
            PrecoExercicio,
            EstiloOpcao,
            IndicadorPremio,
            IdentificadorDistribuicao,
            FatorPreco,
            Liquidacao,
            TipoSerie,
            IndicadorProtecao,
            ExercicioAutomatico,
            CodEspecificacao,
            NomeInstituicao,
            DataInicioEventoCorporativo,
            TratamentoCustodia,
            CapitalSocial,
            GovernancaCorporativa
        }

        props.loading(true)
        return dataLakeService.updateTableEndpoint(props.endpoint, ID, body).then(() => {
            props.loading(false)
        }).catch((err) => {
            props.loading(false)
            throw err
        })
    }

    const deleteRow = async (row) => {
        props.loading(true)
        const { ID } = row

        return dataLakeService.deleteTableEndpoint(props.endpoint, ID).then(() => {
            props.loading(false)
            const listRemoved = data.filter((item) => item.ID !== ID)
            setData(listRemoved)
        }).catch((err) => {
            props.loading(false)
            throw err
        })
    }

    const onFilter = async (filterList, limit, offset) => {
        const query = filterList
            .map(obj => `${encodeURIComponent(obj.field)}=${encodeURIComponent(obj.value)}`)
            .join('&')

        props.loading(true)
        dataLakeService.loadPaginationEndpoint(props.endpoint, query, limit, offset).then((response) => {
            props.loading(false)

            const { body } = response
            const { results, count, next, previous } = body
            const list = results.map((obj) => ({ ...obj, id: obj.ID }))

            setPagination({ count, next, previous })
            setData(list)
        })
    }

    const changePage = async (endpoint) => {
        props.loading(true)
        dataLakeService.paginate(endpoint).then((response) => {
            props.loading(false)

            const { body } = response
            const { results, count, previous, next } = body
            const list = results.map((obj) => ({ ...obj, id: obj.ID }))

            setPagination({ count, next, previous })
            setData([])
            setData(list)
        })
    }

    const columns = [
        {
            field: 'ID',
            headerName: '#',
            minWidth: 80,
            flex: 1,
            disableColumnMenu: true,
            disableFilter: true,
            editable: false,
            type: 'number'
        },

        { field: 'CodigoB3', headerName: 'Código B3', minWidth: 150, flex: 1, disableColumnMenu: true },
        { field: 'ISIN', headerName: 'ISIN', minWidth: 150, flex: 1, disableColumnMenu: true },
        { field: 'CodigoCFI', headerName: 'Código CFI', minWidth: 150, flex: 1, disableColumnMenu: true },
        { field: 'Ativo', headerName: 'Ativo', minWidth: 120, flex: 1, disableColumnMenu: true },
        { field: 'DescricaoAtivo', headerName: 'Descrição do Ativo', minWidth: 250, flex: 1, disableColumnMenu: true },
        { field: 'Segmento', headerName: 'Segmento', minWidth: 200, flex: 1, disableColumnMenu: true },
        { field: 'Mercado', headerName: 'Mercado', minWidth: 200, flex: 1, disableColumnMenu: true },
        { field: 'Categoria', headerName: 'Categoria', minWidth: 200, flex: 1, disableColumnMenu: true },

        {
            field: 'DataExpiracao',
            headerName: 'Data Expiração',
            minWidth: 150,
            flex: 1,
            type: 'date',
            disableColumnMenu: true,
            valueGetter: ({ value }) => (value ? new Date(value) : null),
            valueFormatter: ({ value }) =>
                value instanceof Date && !isNaN(value) ? dayjs(value).format(DATE_FORMAT) : ''
        },
        {
            field: 'DataInicioNegocio',
            headerName: 'Data Início Negócio',
            minWidth: 150,
            flex: 1,
            type: 'date',
            disableColumnMenu: true,
            valueGetter: ({ value }) => (value ? new Date(value) : null),
            valueFormatter: ({ value }) =>
                value instanceof Date && !isNaN(value) ? dayjs(value).format(DATE_FORMAT) : ''
        },
        {
            field: 'DataFimNegocio',
            headerName: 'Data Fim Negócio',
            minWidth: 150,
            flex: 1,
            type: 'date',
            disableColumnMenu: true,
            valueGetter: ({ value }) => (value ? new Date(value) : null),
            valueFormatter: ({ value }) =>
                value instanceof Date && !isNaN(value) ? dayjs(value).format(DATE_FORMAT) : ''
        },

        { field: 'TipoOpcao', headerName: 'Tipo Opção', minWidth: 150, flex: 1, disableColumnMenu: true },
        { field: 'TamanhoLote', headerName: 'Tamanho Lote', minWidth: 150, flex: 1, type: 'number', disableColumnMenu: true },
        { field: 'MoedaNegociada', headerName: 'Moeda Negociada', minWidth: 150, flex: 1, disableColumnMenu: true },
        { field: 'TipoEntrega', headerName: 'Tipo Entrega', minWidth: 150, flex: 1, disableColumnMenu: true },
        { field: 'PrecoExercicio', headerName: 'Preço Exercício', minWidth: 150, flex: 1, type: 'number', disableColumnMenu: true },

        { field: 'EstiloOpcao', headerName: 'Estilo Opção', minWidth: 150, flex: 1, disableColumnMenu: true },
        { field: 'IndicadorPremio', headerName: 'Indicador Prêmio', minWidth: 150, flex: 1, disableColumnMenu: true },
        { field: 'IdentificadorDistribuicao', headerName: 'Identificador Distribuição', minWidth: 180, flex: 1, type: 'number', disableColumnMenu: true },
        { field: 'FatorPreco', headerName: 'Fator Preço', minWidth: 150, flex: 1, type: 'number', disableColumnMenu: true },
        { field: 'Liquidacao', headerName: 'Liquidação', minWidth: 150, flex: 1, type: 'number', disableColumnMenu: true },
        { field: 'TipoSerie', headerName: 'Tipo Série', minWidth: 150, flex: 1, disableColumnMenu: true },
        { field: 'IndicadorProtecao', headerName: 'Indicador Proteção', minWidth: 180, flex: 1, disableColumnMenu: true },
        { field: 'ExercicioAutomatico', headerName: 'Exercício Automático', minWidth: 180, flex: 1, disableColumnMenu: true },
        { field: 'CodEspecificacao', headerName: 'Cód. Especificação', minWidth: 180, flex: 1, disableColumnMenu: true },
        { field: 'NomeInstituicao', headerName: 'Nome Instituição', minWidth: 200, flex: 1, disableColumnMenu: true },

        {
            field: 'DataInicioEventoCorporativo',
            headerName: 'Início Evento Corporativo',
            minWidth: 200,
            flex: 1,
            type: 'date',
            disableColumnMenu: true,
            valueGetter: ({ value }) => (value ? new Date(value) : null),
            valueFormatter: ({ value }) =>
                value instanceof Date && !isNaN(value) ? dayjs(value).format(DATE_FORMAT) : ''
        },

        { field: 'TratamentoCustodia', headerName: 'Tratamento Custódia', minWidth: 180, flex: 1, disableColumnMenu: true },
        { field: 'CapitalSocial', headerName: 'Capital Social', minWidth: 150, flex: 1, type: 'number', disableColumnMenu: true },
        { field: 'GovernancaCorporativa', headerName: 'Governança Corporativa', minWidth: 200, flex: 1, disableColumnMenu: true },

        {
            field: 'CriadoEm',
            headerName: 'Data de Criação',
            minWidth: 150,
            flex: 1,
            disableColumnMenu: true,
            disableFilter: true,
            editable: false,
            renderCell: (params) => formatDateDataGrid(params)
        },
        {
            field: 'AtualizadoEm',
            headerName: 'Data de Atualização',
            minWidth: 150,
            flex: 1,
            disableColumnMenu: true,
            disableFilter: true,
            editable: false,
            renderCell: (params) => formatDateDataGrid(params)
        }
    ]

    return (
        <ParameterPaginationTable
            columns={columns}
            data={data}
            setData={setData}
            createRow={createRow}
            deleteRow={deleteRow}
            updateRow={updateRow}
            filterFunction={onFilter}
            pagination={pagination}
            onChangePage={changePage}
            customFilter={true}
        />
    )
}

ParameterDatalakeB3AcoesRegistradoTable.propTypes = {
    loading: PropTypes.func,
    endpoint: PropTypes.string,
}

export default ParameterDatalakeB3AcoesRegistradoTable
